"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDnd = require("react-dnd");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _cccisdSound = require("cccisd-sound");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cross = _interopRequireDefault(require("cccisd-icons/svg/cross"));
var _cross2 = _interopRequireDefault(require("cccisd-icons/cross4"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _reactDndHtml5Backend = require("react-dnd-html5-backend");
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } /* eslint-disable no-nested-ternary, no-shadow */
var timeToWaitAfterTouch = 120;
var Item = function Item(props) {
  var item = props.item,
    index = props.index,
    correctItems = props.correctItems,
    feedbackTexts = props.feedbackTexts,
    targetId = props.targetId,
    showFeedback = props.showFeedback,
    feedbackPosition = props.feedbackPosition,
    showCorrectness = props.showCorrectness,
    playItemAudio = props.playItemAudio,
    allowDelete = props.allowDelete,
    deleteItem = props.deleteItem,
    showFeedbackMessage = props.showFeedbackMessage,
    placeholder = props.placeholder,
    setPlaceholder = props.setPlaceholder;
  var isCorrect = correctItems.includes(item.id);
  var feedback = feedbackTexts["".concat(item.id, "_").concat(targetId)];
  var ref = (0, _react.useRef)(null);
  var _useDrag = (0, _reactDnd.useDrag)({
      item: {
        type: 'item',
        id: item.id,
        group: item.type,
        label: item.label,
        from: targetId
      },
      begin: function begin(monitor) {
        setPlaceholder({
          targetId: targetId,
          indexAfter: index,
          width: ref.current.offsetWidth,
          height: ref.current.offsetHeight,
          html: ref.current.innerHTML
        });
      },
      end: function end(draggedItem, monitor) {
        setPlaceholder(null);
      },
      collect: function collect(monitor) {
        return {
          isDragging: monitor.isDragging()
        };
      }
    }),
    _useDrag2 = _slicedToArray(_useDrag, 3),
    isDragging = _useDrag2[0].isDragging,
    drag = _useDrag2[1],
    preview = _useDrag2[2];

  // Don't show any images on preview
  (0, _react.useEffect)(function () {
    preview((0, _reactDndHtml5Backend.getEmptyImage)());
  }, []);

  // To avoid flickering we'll show placeholder only when dragging started
  (0, _react.useEffect)(function () {
    if (isDragging && placeholder) {
      setPlaceholder({
        show: true
      });
    }
  }, [isDragging]);
  var _useDrop = (0, _reactDnd.useDrop)({
      accept: 'item',
      hover: function hover(draggedItem, monitor) {
        if (!ref.current) {
          return;
        }
        if (draggedItem.id === item.id && draggedItem.group === item.type) {
          return;
        }

        // Determine rectangle on screen
        var hoverBoundingRect = ref.current.getBoundingClientRect();

        // Get vertical middle
        var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

        // Determine mouse position
        var clientOffset = monitor.getClientOffset();

        // Get pixels to the top
        var hoverClientY = clientOffset.y - hoverBoundingRect.top;
        if (hoverClientY < hoverMiddleY) {
          setPlaceholder({
            targetId: targetId,
            indexAfter: index - 1
          });
        } else {
          setPlaceholder({
            targetId: targetId,
            indexAfter: index
          });
        }
      }
    }),
    _useDrop2 = _slicedToArray(_useDrop, 2),
    drop = _useDrop2[1];
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    grabbed = _useState2[0],
    setGrabbed = _useState2[1];
  (0, _react.useEffect)(function () {
    var timeout;
    var element = ref.current;
    var handleTouchStart = function handleTouchStart() {
      setGrabbed(false);
      timeout = setTimeout(function () {
        setGrabbed(true);
      }, timeToWaitAfterTouch);
    };
    var handleTouchMove = function handleTouchMove() {
      clearTimeout(timeout);
    };
    var handleTouchEnd = function handleTouchEnd() {
      clearTimeout(timeout);
      setGrabbed(false);
    };
    element.addEventListener('touchstart', handleTouchStart, false);
    element.addEventListener('touchmove', handleTouchMove, false);
    element.addEventListener('touchend', handleTouchEnd, false);
    element.addEventListener('touchcancel', handleTouchEnd, false);
    return function () {
      element.removeEventListener('touchstart', handleTouchStart);
      element.removeEventListener('touchmove', handleTouchMove);
      element.removeEventListener('touchend', handleTouchEnd);
      element.removeEventListener('touchcancel', handleTouchEnd);
    };
  }, []);
  var _useState3 = (0, _react.useState)(Boolean(feedback && !isDragging)),
    _useState4 = _slicedToArray(_useState3, 2),
    showTooltip = _useState4[0],
    setShowTooltip = _useState4[1];
  (0, _react.useEffect)(function () {
    if (!showFeedback || isDragging || !feedback) {
      return;
    }
    if (feedbackPosition === 'fixed') {
      showFeedbackMessage(feedback, showCorrectness ? isCorrect : null);
      return;
    }
    var timer = setTimeout(function () {
      setShowTooltip(false);
    }, 3000);
    return function () {
      return clearTimeout(timer);
    };
  }, []);
  var audioUrl = (0, _get2["default"])(item.label, 'meta.audio.url');
  drag(drop(ref));
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    ref: ref,
    className: (0, _classnames2["default"])(_style["default"].sourceItem, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _style["default"].right, showCorrectness && isCorrect), _style["default"].wrong, showCorrectness && !isCorrect), _style["default"].hidden, isDragging), _style["default"].grabbed, grabbed)),
    "data-item": true
  }, playItemAudio && audioUrl && {
    onMouseDown: function onMouseDown() {
      (0, _cccisdSound.play)(audioUrl);
    }
  }, showCorrectness && !isCorrect && {
    onClick: function onClick() {
      deleteItem(item);
    }
  }), showFeedback && showTooltip && feedbackPosition === 'tooltip' && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].tooltipBase
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: feedback
    }),
    type: showCorrectness ? isCorrect ? 'success' : 'error' : '',
    tippyProps: {
      trigger: 'manual',
      showOnCreate: true,
      delay: [100, 0]
    }
  })), showCorrectness && /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].icon
  }, isCorrect ? /*#__PURE__*/_react["default"].createElement(_checkmark["default"], {
    spaceRight: true
  }) : /*#__PURE__*/_react["default"].createElement(_cross2["default"], {
    spaceRight: true
  })), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: item.label
  }), allowDelete && item.type === 'user' && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].deleteItem,
    "data-delete-item": true,
    onClick: function onClick() {
      return deleteItem(item);
    }
  }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)));
};
Item.propTypes = {
  item: _propTypes["default"].object.isRequired,
  index: _propTypes["default"].number.isRequired,
  correctItems: _propTypes["default"].array,
  feedbackTexts: _propTypes["default"].object,
  targetId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  showFeedback: _propTypes["default"].bool,
  feedbackPosition: _propTypes["default"].string,
  showCorrectness: _propTypes["default"].bool,
  playItemAudio: _propTypes["default"].bool,
  allowDelete: _propTypes["default"].bool,
  deleteItem: _propTypes["default"].func.isRequired,
  showFeedbackMessage: _propTypes["default"].func,
  placeholder: _propTypes["default"].object,
  setPlaceholder: _propTypes["default"].func.isRequired
};
Item.defaultProps = {
  allowDelete: true,
  showCorrectness: false,
  showFeedback: false,
  playItemAudio: false,
  correctItems: [],
  targetId: 0,
  feedbackTexts: {},
  feedbackPosition: 'tooltip'
};
var _default = exports["default"] = Item;